<template>
  <div :class="['dh-psy-journal', {
    'dh-psy-journal--left': align === 'left',
    'dh-psy-journal--right': align === 'right',
    'dh-psy-journal--inverse': inverse
  }]">
    <div class="dh-psy-journal__wrapper">
      <h4 v-if="title">{{ this.title }}</h4>
      <p>
        <span>{{ content }}</span>
      </p>
      <p class="dh-psy-journal__author" v-if="author" v-html="author"></p>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
  .dh-psy-journal {
    display: flex;
    width: calc(100% - 2em);

    padding: 1em 2em;
    box-sizing: border-box;
    margin: auto;
    font-weight: 300;
    font-family: 'Times New Roman', Times, serif;
    font-family: menlo, inconsolata, consolas, 'fira mono', 'noto mono', 'droid sans mono',
      'dejavu sans mono', 'liberation mono', 'ubuntu mono', monaco, 'courier new', monospace;
    font-size: 0.7em;
    line-height: 1.6;
    border: 1px solid #eee;

    @media (min-width: 800px) {
      width: calc(100%);
      font-size: 0.8em;
    }

    &.dh-psy-journal--right,
    &.dh-psy-journal--left {
      justify-content: center;
    }

    @media (min-width: 900px) {
      padding: 2em;

      &.dh-psy-journal--right {
        justify-content: flex-end;
      }

      &.dh-psy-journal--left {
        justify-content: flex-start;
      }
    }

    & .dh-psy-journal__wrapper {
      float: none;
      margin: 0;
      box-sizing: border-box;

      display: inline-block;

      @media (min-width: 900px) {
        max-width: 600px;
      }
    }

    &.dh-psy-journal--inverse {
      color: #fff;
      background: #141516;
    }

    & h4 {
      margin: 1.2em 0 1em;
      box-sizing: border-box;
    }
  }
  p {
    box-sizing: border-box;
    margin-top: 10px;
    margin-bottom: 1em;
  }

  .dh-psy-journal__author {
    margin: 2em 0 0;

    & :global(span) {
      display: inline-block;
      background: black;
      color: black;
      color: transparent;
      line-height: 1.2;
      user-select: none;
    }
  }

  .dh-psy-journal__censor {
    word-break: break-all;

    box-shadow: 0 0 0 2px #fff inset;
    background-color: rgba(153, 153, 153);
    background-color: black;
    color: rgb(153, 153, 153);
    color: rgba(153, 153, 153, 0);
    line-height: 1;
    user-select: none;
  }
</style>

<script>
import image from '../../../assets/sladd-test-3.png'

export default {
  data() {
    return {
      image
    }
  },
  props: {
    align: {
      type: String,
      required: false,
      default: ''
    },
    content: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    author: {
      type: String,
      required: false
    },
    date: {
      type: String,
      required: false
    },
    inverse: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
